import { Tarea, TareaPageResponse } from '../../model/tarea/tarea';

/**
 * Puerto Abstracto: TareaRepository
 * 
 * Define el contrato para operaciones con Tareas/Homologaciones.
 * Migrado del legacy GWT UtilidadesBuscadores.buscarTarea().
 * 
 * Arquitectura Hexagonal:
 * - Este puerto está en el dominio
 * - HttpTareaRepository (adaptador) lo implementa en infraestructura
 * 
 * @author Ingeneo - Migración GWT
 */
export abstract class TareaRepository {
  
  /**
   * Busca tareas por filtro de texto (sin paginación, compatibilidad)
   */
  abstract buscarPorFiltro(filtro: string, limit?: number): Promise<Tarea[]>;
  
  /**
   * @deprecated Usar buscarPaginado en su lugar
   */
  abstract contarPorFiltro(filtro: string): Promise<number>;

  /**
   * Busca tareas por código y/o nombre con paginación por cursor (keyset
   * pagination, ver skill acceso-datos-oracle §7).
   * Devuelve content + totalElements en una sola llamada.
   *
   * @param codigo Código de homologación (búsqueda exacta, puede ser null)
   * @param nombre Nombre/descripción (búsqueda parcial, puede ser null)
   * @param cursor Cursor de la página (null = primera página)
   * @param size Tamaño de página
   * @param filtrarFebaja false = variante normal, true = Sin Orientación de Servicio
   * @param direction NEXT | PREVIOUS | LAST
   */
  abstract buscarPaginado(
    codigo: string | null,
    nombre: string | null,
    cursor: string | null,
    size: number,
    filtrarFebaja: boolean | undefined,
    direction: 'NEXT' | 'PREVIOUS' | 'LAST'
  ): Promise<TareaPageResponse>;
}
